import React, { ReactNode } from 'react';
import styles from './visualiser-group.module.css';

type VisualiserGroupProps = {
  children?: ReactNode;
  className?: string;
};

export const VisualiserGroup = ({ children, className }: VisualiserGroupProps) => {
  const groupedChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;

    // Only add props to React components (not DOM nodes like <div />).
    if (typeof child.type === 'string') return child;

    const visualiserType = child.props?.type;
    const isVisualiser = visualiserType === 'INSERT' || visualiserType === 'GREETINGS_CARD';
    if (!isVisualiser) return child;

    // Ensure Visualiser children have no margin so the group can be truly gapless.
    return React.cloneElement(child, { isGrouped: true });
  });

  const rootClassName = className
    ? `${styles['visualiser-group']} ${className}`
    : styles['visualiser-group'];

  return (
    <div className={rootClassName}>
      {groupedChildren}
    </div>
  );
};


